import classNames from 'classnames'
import { memo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../../../../store/global-store'
import type { LiveGuest } from '../../../../../../types/lives/live'

interface Props {
  guest: LiveGuest
  handleSelectUserToGift: (id: number) => void
}

export const Gifter = memo(({ guest, handleSelectUserToGift }: Props) => {
  const { isSelected } = useGlobalStore(
    useShallow((state) => ({
      isSelected: state.usersToGift.has(guest?.userId),
    })),
  )

  const isInvisible = guest?.user?.privacy?.invisibleVisitor

  return (
    <img
      src={!isInvisible ? guest?.user?.imgUser : undefined}
      onClick={() => handleSelectUserToGift(guest.userId)}
      className={classNames(
        'w-8 h-8 rounded-full bg-black/60 object-cover shrink-0 transition-all',
        {
          'ring-2 ring-hug-purple shadow-[0_0_8px_rgba(155,48,230,0.55)]':
            isSelected,
          'opacity-70': !isSelected,
        },
      )}
    />
  )
})
